const SCROLLED_CLASS = 'is-scrolled';
const SCROLL_THRESHOLD = 50;
const SCROLL_SYNC_DELAY = 250;

let syncBodyScrollClassTimeout;
let isBodyScrollClassSyncLocked = false;

const syncBodyScrollClass = () => {
    if (!document.body) {
        return;
    }

    document.body.classList.toggle(SCROLLED_CLASS, window.scrollY > SCROLL_THRESHOLD);
};

const scheduleBodyScrollClassSync = () => {
    if (!document.body) {
        return;
    }

    if (isBodyScrollClassSyncLocked) {
        return;
    }

    const shouldBeScrolled = window.scrollY > SCROLL_THRESHOLD;
    const isScrolled = document.body.classList.contains(SCROLLED_CLASS);

    if (shouldBeScrolled === isScrolled) {
        return;
    }

    syncBodyScrollClass();
    isBodyScrollClassSyncLocked = true;
    window.clearTimeout(syncBodyScrollClassTimeout);
    syncBodyScrollClassTimeout = window.setTimeout(() => {
        isBodyScrollClassSyncLocked = false;
    }, SCROLL_SYNC_DELAY);
};

document.addEventListener('DOMContentLoaded', () => {
    syncBodyScrollClass();
    window.addEventListener('scroll', scheduleBodyScrollClassSync, { passive: true });
});
